module.exports = {
  path: 'activate',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/DevicesActivate'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/devices/routes/activate/index.js